import React from 'react';

import { Helmet } from 'react-helmet';

type zendeskKeyType = string | null;

const zendeskKey: zendeskKeyType = process.env.REACT_APP_ZENDESK_KEY;

const Zendesk = () => {
  return (
    <Helmet>
      <script
        id="ze-snippet"
        src={`https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`}
      ></script>
    </Helmet>
  );
};

export default Zendesk;
